import type { TMessageData } from "@asurion-core/headless-chat-web";
import type { Logger } from "@expert/logging";

import { MESSAGE_DATA_TYPES, SimplrChatSDK } from "@asurion-core/headless-chat-web";

import type { AnalyticsInfo, SessionMetadata } from "../store";
import type { GuideSelectionObject } from "./types";

export function navigateBack({ restartFlow = false }: { restartFlow?: boolean }) {
    if (restartFlow) {
        void SimplrChatSDK.navigateBack({ startOver: true });
    } else {
        void SimplrChatSDK.navigateBack();
    }
}

/*
   Calling startSession for a sessionId with an existing session will not
   restart the session, it will pick back up wherever the session left off.
   This allows for managing multiple sessions at a given time.
*/
export function startSimplrSession({ sessionId, metadata }: { sessionId: string; metadata?: SessionMetadata }) {
    void SimplrChatSDK.startSession({ externalTicketId: sessionId, moreTicketInfo: metadata });
}

/*
    for our use case, we can not use startSession to store moreTicketInfo in
    the logic builder because the Simplr team ignores back to back startSession
    calls for the same sessionId. Instead, we use sendClientMetaData to update
    the moreTicketInfo for an existing session and store it in logic builder.
*/
export function sendMetadata({ metadata }: { metadata?: SessionMetadata }) {
    void SimplrChatSDK.sendClientMetaData({ moreTicketInfo: metadata });
}

export function triggerNextStep(option: string, logger: Logger, onBeforeSend?: () => void) {
    const messageData = {
        type: MESSAGE_DATA_TYPES.TEXT,
        text: option,
    } as TMessageData;

    logger.info(`Solve Guide | calling triggerNextStep with: ${option}`);
    if (onBeforeSend) {
        onBeforeSend();
    }
    void SimplrChatSDK.sendMessage(messageData);
}

export function automaticallySelectGuideIfNeeded(
    analyticsInfo: AnalyticsInfo,
    availableGuides: GuideSelectionObject[],
    guide: string,
    logger: Logger,
    onBeforeSend?: () => void,
) {
    if (
        availableGuides.map((guide) => guide.title)?.includes(guide) &&
        analyticsInfo.currentStepId === "GuideSelection"
    ) {
        triggerNextStep(guide, logger, onBeforeSend);
        logger.info(`Solve Guide | Selected flow automatically: ${guide}`);
    } else {
        logger.info({ availableGuides, ...analyticsInfo }, `Solve Guide | NOT selecting flow automatically: ${guide}`);
    }
}
